import { ScheduleEntryModel } from './scheduleEntry.model';

export class ScheduleModel {
    constructor(
        public defaultPresentationId?: string,
        public scheduleIsDisabled?: boolean,
        public entries?: ScheduleEntryModel[]
    ) { }
}


// WEBPACK FOOTER //
// ./src/app/views/devices/models/schedule.model.ts